import { useEffect, useReducer } from 'react';

import type { SaveState } from '../views/contract.js';
import {
  ETAT_INDICATEUR_INITIAL,
  reduireIndicateur,
  type EtatIndicateur,
  type EvenementIndicateur,
} from './indicateurEnregistrement-regles.js';

interface Action {
  evenement: EvenementIndicateur;
  maintenant: number;
}

const reducteur = (etat: EtatIndicateur, { evenement, maintenant }: Action): EtatIndicateur =>
  reduireIndicateur(etat, evenement, maintenant);

/**
 * LE HOOK DE L'INDICATEUR D'ENREGISTREMENT : la colle entre `saveState` et la
 * machine pure (`indicateurEnregistrement-regles.ts`), rien de plus.
 *
 * Il envoie le mode a chaque NOUVEL objet `saveState` (le moteur en pose un a
 * chaque transition), pose UN SEUL `setTimeout` sur l'echeance de l'etat, et le
 * nettoie quand l'echeance change ou au demontage. Les regles (qui montre quoi,
 * apres quel delai) ne sont pas ici.
 */
export function useIndicateurEnregistrement(saveState: SaveState): EtatIndicateur {
  const [etat, envoyer] = useReducer(reducteur, ETAT_INDICATEUR_INITIAL);

  useEffect(() => {
    envoyer({ evenement: saveState.mode, maintenant: Date.now() });
  }, [saveState]);

  const { echeance } = etat;
  useEffect(() => {
    if (echeance === null) return undefined;
    const minuteur = setTimeout(
      // Un minuteur peut tomber une milliseconde avant l'heure : l'echeance
      // est alors le plancher, sinon la machine ignorerait l'evenement et
      // l'indicateur resterait fige.
      () => envoyer({ evenement: 'minuteur', maintenant: Math.max(Date.now(), echeance) }),
      Math.max(0, echeance - Date.now()),
    );
    return () => clearTimeout(minuteur);
  }, [echeance]);

  return etat;
}
